import { render, staticRenderFns } from "./AppLayoutAdmin.vue?vue&type=template&id=522fb69e&scoped=true"
import script from "./AppLayoutAdmin.vue?vue&type=script&lang=js"
export * from "./AppLayoutAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522fb69e",
  null
  
)

export default component.exports